import Cart from '@kega/sps-connector-occ/src/Cart';
import Customer from '@kega/sps-connector-occ/src/Customer';
import Catalog from '@kega/sps-connector-occ/src/Catalog';
import Cms from '@kega/sps-connector-occ/src/Cms';
import Navigation from '@kega/sps-connector-occ/src/Navigation';
import Checkout from '@kega/sps-connector-occ/src/Checkout';
import Tokens from '@kega/sps-connector-occ/src/tokens/Tokens';

import OccClient from './OccClient';

const OCC = (config, options) => {
    const client = OccClient(config, options);

    const tokens = new Tokens({
        url: config.url,
        client_id: options.authentication.client_id,
        client_secret: options.authentication.client_secret,
    });

    const apiProps = {
        client,
        config,
        tokens,
    };

    const api = {
        cart: Cart(apiProps),
        customer: Customer(apiProps),
        catalog: Catalog(apiProps),
        cms: Cms(apiProps),
        navigation: Navigation(apiProps),
        checkout: Checkout(apiProps),
    };

    return {
        api,
        register: (registerApi) => registerApi(apiProps),
    };
};

export default OCC;
